import axios from 'axios';
import { defaultFirebaseAuth } from 'config/firebase-config';
import { signInWithCustomToken } from 'firebase/auth';

export default axios.create({
  baseURL: process.env.REACT_APP_API_SALES_URL,
  responseType: 'json',
});

export const handleRegisterWithCustomToken = async (customToken: string) => {
  const userCredential = await signInWithCustomToken(
    defaultFirebaseAuth,
    customToken
  );
  return userCredential.user;
};
